/* eslint-disable */
import * as util from "@/api/store";

const state = {
  isShowForm: false,
  formParamSt: {
    id: "",
    brand_id: "",
    mp_id: "",
    store_name: "",
    store_link: ""
  }
};

const mutations = {
  SET_formParamSt: (state, value) => {
    state.formParamSt = value;
  },
  SET_isShowForm: (state, value) => {
    state.isShowForm = value;
  }
};

const actions = {
  create({ commit }, dataParam) {
    return new Promise((resolve, reject) => {
      util
        .create(dataParam)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  update({ commit }, dataParam) {
    return new Promise((resolve, reject) => {
      util
        .update(dataParam)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteData({ commit }, params) {
    return new Promise((resolve, reject) => {
      util
        .deleteData(params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  list({ commit }, params) {
    return new Promise((resolve, reject) => {
      util
        .list(params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  setIsShowForm({ commit }, data) {
    commit("SET_isShowForm", data);
  },
  actFormParamSt({ commit }, data) {
    commit("SET_formParamSt", data);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/store.js